module.exports = __webpack_public_path__ + "static/media/young5_s.0c1da1de.jpg";